import { h, Component } from 'preact';
import { Link } from 'components/core/link/link';
import Button from 'components/shared/button/button';
import { joinClasses, sortObjectByOrder, accessNested } from 'utils/utils';
import * as BaseComp from 'components/shared/header/header.js';
import s from 'components/shared/header/header.sss';
import Store from 'store/store';
import * as actions from 'store/actions';

const HEADER_COLOR_THRESHOLD = 100;

export default class Header extends BaseComp.default {
	constructor(props) {
		super(props);

		this.state = {
			menuOpen: false,
			regionSelectorOpen: false,
			showBg: false
		};

		this.toggleMenuOpen           = this.toggleMenuOpen.bind(this);
		this.toggleRegionSelectorOpen = this.toggleRegionSelectorOpen.bind(this);
		this.handleScroll             = this.handleScroll.bind(this);
		this.handleClick              = this.handleClick.bind(this);
		this.renderLogo               = this.renderLogo.bind(this);
	}

	componentDidMount() {
		window.addEventListener('scroll', this.handleScroll);
		window.addEventListener('click', this.handleClick);
	}

	componentWillUnmount() {
		window.removeEventListener('scroll', this.handleScroll);
		window.removeEventListener('click', this.handleClick);
	}

	handleScroll() {
		const { showBg } = this.state;
		let newShowBg = false

		if (document.documentElement.scrollTop > HEADER_COLOR_THRESHOLD) {
			newShowBg = true;
		}

		if (showBg !== newShowBg) {
			this.setState({ showBg: newShowBg });
		}
	}

	handleClick(e) {
		const isMobile = accessNested(this.props, 'client.deviceSize') !== 'desktop';

		if (!isMobile) {
			if (this.state.menuOpen) {
				const isMenu = this.menu && (this.menu.contains(e.target) || this.menu === e.target);
				const isMenuButton = this.menuButton && (this.menuButton.contains(e.target) || this.menuButton === e.target);

				if (!isMenu && !isMenuButton) {
					this.toggleMenuOpen();
				}
			}

			if (this.state.regionSelectorOpen) {
				const isRegionSelector = this.regionSelector && (this.regionSelector.contains(e.target) || this.regionSelector === e.target);
				const isRegionSelectorButton = this.regionSelectorButton && (this.regionSelectorButton.base.contains(e.target) || this.regionSelectorButton.base === e.target);

				if (!isRegionSelector && !isRegionSelectorButton) {
					this.toggleRegionSelectorOpen();
				}
			}
		}
	}

	toggleMenuOpen() {
		const { menuOpen } = this.state;
		this.setState({ menuOpen: !menuOpen });
		const isDesktop = this.props.client.deviceSize === 'desktop';

		if (isDesktop) {
			if (!menuOpen) {
				this.setState({ regionSelectorOpen: false });
			}
			return;
		}

		if (menuOpen) {
			Store.emit(actions.SCROLL_UNLOCK);
		} else {
			Store.emit(actions.SCROLL_LOCK);
		}
	}

	toggleRegionSelectorOpen() {
		const { regionSelectorOpen } = this.state;
		this.setState({ regionSelectorOpen: !regionSelectorOpen });

		const isDesktop = this.props.client.deviceSize === 'desktop';
		
		if (isDesktop && !regionSelectorOpen) {
			this.setState({ menuOpen: false });
		}
	}

	renderLogo(logo) {
		const { menuOpen } = this.state;
		const { client }   = this.props;
		
		const {
			src       = '',
			alt       = '',
			ariaLabel = '',
			pageId    = '',
			title     = ''
		} = logo;

		const black = menuOpen && client.deviceSize === 'mobile';

		return (
			<Link class={s.homeBtn} title={title} ariaLabel={ariaLabel} renderCustomChild pageId={pageId}>
				<img class={joinClasses(s.logo, black && s.black)} src={src} alt={alt} />
			</Link>
		);
	}

	renderRegionSelector(regionSelector) {
		if (!Object.keys(regionSelector).length) return;
		const { regionSelectorOpen } = this.state;
		const activeRegionCode       = accessNested(this.props, 'appData.meta.region.slug');
		const activeRegion           = regionSelector.regions[activeRegionCode];
		const otherRegions           = sortObjectByOrder(regionSelector.regions).filter(region => region.code !== 'gb');
		const buttonData             = {
			...activeRegion,
			icon: regionSelector.icon.desktop,
			type: 'regionSelector',
			ariaLabel: regionSelector.ariaLabel,
			title: ''
		};
		delete buttonData.href;

		return (
			<div class={s.regionSelector} ref={ref => this.regionSelector = ref}>
				<Button
					ref={ref => this.regionSelectorButton = ref}
					link={false}
					data={buttonData}
					extraClass={s.currentRegion}
					client={this.props.client}
					extraOnClick={this.toggleRegionSelectorOpen}
					regionSelectorOpen={regionSelectorOpen}
				/>
				<ul class={joinClasses(s.regionDropdown, regionSelectorOpen ? s.open : s.closed)}>
					{otherRegions.map(region => {
						const {
							label     = '',
							href      = '',
							ariaLabel = '',
							title     = '',
							code      = ''
						} = region;

						return <li class={s.region}>
							<Link
								ariaLabel={ariaLabel}
								href={href}
								title={title}
								rel='noopener'
								extraOnClick={() => { Store.emit(actions.POWSTER_GA_EVENT_TRACK, 'origin', 'region', activeRegionCode + '_' + code); }}
							>
								{region.label}
							</Link>
						</li>;
					})}
				</ul>
			</div>
		);
	}

	renderMenuRegionSelector(regionSelector) {
		const { regionSelectorOpen } = this.state;
		const activeRegionCode       = accessNested(this.props, 'appData.meta.region.slug');
		const activeRegion           = regionSelector.regions[activeRegionCode];
		const otherRegions           = sortObjectByOrder(regionSelector.regions);
		const buttonData             = { ...activeRegion, icon: regionSelector.icon.mobile, type: 'menuRegionSelector' };
		delete buttonData.href;

		return (
			<div style={{ position: 'relative' }}>
				<Button
					link={false}
					data={buttonData}
					extraClass={joinClasses(s.menuItem, s.menuRegionSelector)}
					client={this.props.client}
					extraOnClick={this.toggleRegionSelectorOpen}
					regionSelectorOpen={regionSelectorOpen}
				/>
				<ul class={joinClasses(s.regionDropdown, regionSelectorOpen ? s.open : s.closed)}>
					{otherRegions.map(region => {
						const {
							label = '',
							href  = '',
							ariaLabel = '',
							title = '',
							code = ''
						} = region;

						return <Link
							class={s.region}
							ariaLabel={ariaLabel}
							href={href}
							title={title}
							extraOnClick={() => { Store.emit(actions.POWSTER_GA_EVENT_TRACK, 'origin', 'region', activeRegionCode + '_' + code); }}
						>
							{region.label}
						</Link>;
					})}
				</ul>
			</div>
		);
	}

	renderTicketBtn(ticketBtn) {
		const { menuOpen } = this.state;
		const data = { ...ticketBtn, type: 'ticket' };

		return <Button
			data={data}
			extraClass={s.ticketBtn}
			menuOpen={menuOpen}
			client={this.props.client}
			extraOnClick={() => Store.emit(actions.POWSTER_GA_EVENT_TRACK, 'nav-click', 'navigation', data.label)}
		/>
	}

	renderMenuBtn(menuBtn) {
		const { menuOpen } = this.state;

		const {
			label     = '',
			title     = {},
			ariaLabel = ''
		} = menuBtn;

		const titleState = menuOpen ? 'open' : 'closed';

		return (
			<button class={s.menuBtn} onClick={this.toggleMenuOpen} title={title[titleState]} ariaLabel={ariaLabel} ref={ref => this.menuButton = ref}>
				<div class={joinClasses(s.burger, menuOpen ? s.open : s.closed)}>
					<div class={joinClasses(s.line, s.top)} />
					<div class={joinClasses(s.line, s.middle)}/>
					<div class={joinClasses(s.line, s.bottom)} />
				</div>
				<span>{label}</span>
			</button>
		);
	}

	renderMenu(homeBtn, regionSelector, ticketBtn, menuLinks, socials) {
		const { menuOpen } = this.state;
		const {
			deviceSize  = 'mobile',
		} = this.props.client;

		const items = sortObjectByOrder(menuLinks);
		const isDesktop = deviceSize === 'desktop';
		const showTicketBtn = !isDesktop;
		const showRegionSelector = Object.keys(regionSelector).length > 0 && !isDesktop;

		return (
			<div class={joinClasses(s.menu, menuOpen ? s.open : s.closed)} ref={ref => this.menu = ref}>
				<div class={s.menuContainer}>
					<ul class={s.links}>
						<li>{this.renderMenuLink(homeBtn)}</li>
						{showRegionSelector && <li class={s.regionSelectorWrapper}>{this.renderMenuRegionSelector(regionSelector)}</li>}
						{showTicketBtn && <li>{this.renderMenuLink(ticketBtn)}</li>}
						{items.map(item => {
							return <li>{this.renderMenuLink(item)}</li>
						})}
					</ul>
					{this.renderSocials(socials)}
				</div>
			</div>
		);
	}

	renderMenuLink(data) {
		let buttonData = { ...data, type: 'menu' };

		const extraOnClick = () => {
			this.toggleMenuOpen();
			if (buttonData.label === 'Sign up') {
				Store.emit(actions.POWSTER_GA_EVENT_TRACK, 'nav', 'signup', 'signup');
			}
			Store.emit(actions.POWSTER_GA_EVENT_TRACK, 'nav-click', 'navigation', buttonData.label);
		};
		return <Button data={buttonData} extraClass={s.menuItem} client={this.props.client} extraOnClick={extraOnClick} />
	}

	renderSocials(data) {
		const socials = sortObjectByOrder(data);

		return (
			<ul class={s.socials}>
				{socials.map(item => {
					const {
						icon      = '',
						href      = '',
						label     = '',
						alt       = '',
						title     = '',
						ariaLabel = '',
						type      = ''
					} = item;

					return <li class={s.social}>
						<Link
							href={href}
							title={title}
							ariaLabel={ariaLabel}
							target='_blank'
							rel='noopener'
							extraOnClick={() => {Store.emit(actions.POWSTER_GA_EVENT_TRACK, 'follow', 'social', type)}}
						>
							<img class={s.icon} src={icon} alt={alt} />
						</Link>
					</li>;
				})}
			</ul>
		);
	}

	render({ appData, client }, { showBg }) {
		const {
			logo           = {},
			regionSelector = {},
			ticketBtn      = {},
			menuBtn        = {},
			homeBtn        = {},
			menuLinks      = {}
		} = appData.header;

		const {
			socials = {}
		} = appData.footer;

		const isDesktop = client.deviceSize === 'desktop';

		return (
			<header class={joinClasses(s.header, showBg ? s.background : s.gradient)}>
				<nav class={s.nav}>
					{this.renderLogo(logo)}
					<div class={s.content}>
						{isDesktop && this.renderRegionSelector(regionSelector)}
						{this.renderTicketBtn(ticketBtn)}
						{this.renderMenuBtn(menuBtn)}
						{this.renderMenu(homeBtn, regionSelector, ticketBtn, menuLinks, socials)}
					</div>
				</nav>
			</header>
		);
	}
}
